import { render, staticRenderFns } from "./UserTask.vue?vue&type=template&id=0fa51a8c&scoped=true"
import script from "./UserTask.vue?vue&type=script&lang=js"
export * from "./UserTask.vue?vue&type=script&lang=js"
import style0 from "./UserTask.vue?vue&type=style&index=0&id=0fa51a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa51a8c",
  null
  
)

export default component.exports